module.exports = __webpack_public_path__ + "static/media/flowers.47ef8145.png";